module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/de-portal-app-shell/',
  octopusPackageId: 'de-portal-app-shell',
  octopusProjectName: 'DE Portal App Shell',
  mountDOMId: '__de-portal-app-shell__',
  standalone: false
};